import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

/**
 * Chiếm luôn `/pricing`. Screen `pages/pricing` (3 gói trả phí) KHÔNG bị xoá — nó chỉ
 * thôi được đăng ký khi `ENABLE_PAID_PLANS = false`, để nguyên chờ mốc thu phí 01/01/2027.
 * Xem `router/routes.ts` + `consts/constant.ts`.
 */
export const pricingFreeRoutes = {
  name: 'pricing-free',
  path: 'pricing',
  component: () => import('./PricingFree.vue'),
  meta: { i18n },
} satisfies RouteRecordRaw;
